import { useMutation, useQueryClient } from "@tanstack/react-query";
import { changeVariantProject } from "../openapi/api-client";

export const useChangeVariantProject = (projectId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => changeVariantProject({ projectId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["variantStatus"] });
    },
  });
};
